interface SepoliaIconProps {
  className?: string
}

export function SepoliaIcon({ className }: SepoliaIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 101 101" className={className}>
      <rect width="100" height="100" x=".5" y=".5" fill="#fff" rx="50" />
      <g stroke="#1616B4" strokeLinejoin="round" strokeWidth=".461" clipPath="url(#a)">
        <path fill="#F0CDC2" d="M50.504 91.974v-20.81L24.76 56.107l25.744 35.866Z" />
        <path fill="#C9B3F5" d="M50.59 91.974v-20.81l25.744-15.056L50.59 91.974Z" />
        <path fill="#88AAF1" d="M50.504 65.991v-26.56l-26.04 11.66 26.04 14.9Z" />
        <path fill="#C9B3F5" d="M50.59 65.991v-26.56l26.04 11.66-26.04 14.9Z" />
        <path fill="#F0CDC2" d="m24.465 51.09 26.04-42.065V39.43l-26.04 11.66Z" />
        <path fill="#B8FAF6" d="M76.63 51.09 50.59 9.025V39.43l26.04 11.66Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M24.004 8.564h52.995v83.871H24.004z" />
        </clipPath>
      </defs>
    </svg>
  )
}
